var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#id-79a)" },
      React.createElement("circle", { cx: "10", cy: "10", r: "10", fill: "#258518", fillOpacity: ".12" }),
      React.createElement("path", { d: "M5.91797 10.0002L8.83464 12.9168L14.668 7.0835", stroke: "#14C17B", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "id-79a" },
        React.createElement("path", { fill: "#fff", d: "M0 0H20V20H0z" })
      )
    )
  );
});